import { Link } from "react-router-dom";
import { ArrowRight, Globe, Palette, Store } from "lucide-react";

/**
 * The cross-sell every tenant site carries at the bottom: this whole site is a product.
 * The house shop gets the loud version — it is the platform's own showroom.
 */
export function PoweredBy({ store, loud }) {
    return (
        <section className={loud ? "border-t border-black/10 bg-zinc-950 text-white" : "border-t border-black/10 bg-zinc-50"} data-testid="powered-by-13thav">
            <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 md:py-16">
                <div className="grid items-center gap-8 lg:grid-cols-[1.4fr_1fr]">
                    <div>
                        <p className={`font-mono text-[11px] uppercase tracking-[0.28em] ${loud ? "text-blue-300" : "text-zinc-500"}`}>
                            Powered by 13thav
                        </p>
                        <h2 className={`mt-3 font-display text-3xl font-extrabold leading-[0.95] tracking-tight sm:text-4xl lg:text-5xl ${loud ? "text-white" : "text-zinc-900"}`}
                            data-testid="powered-by-headline">
                            {loud ? "This website is for sale." : "Own a print shop? You can get this exact website."}
                        </h2>
                        <p className={`mt-4 max-w-xl text-base ${loud ? "text-zinc-300" : "text-zinc-600"}`}>
                            {loud
                                ? `Every designer, every product and the checkout you just used run on 13thav. Other print shops rent the same website with their own logo, prices and Stripe account. It is set up in minutes, not months.`
                                : `${store?.name || "This shop"} runs on 13thav. The live designers, the Shirts and Signs menus, the Stripe checkout and the order inbox all come with it. You can have the same website in minutes.`}
                        </p>
                        <div className="mt-6 flex flex-wrap gap-3">
                            <Link to="/whitelabel" data-testid="powered-by-cta"
                                className={`inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-bold uppercase tracking-wide transition-transform hover:scale-[1.03] ${loud ? "bg-white text-zinc-950" : "bg-zinc-950 text-white"}`}>
                                See plans from $9 a month <ArrowRight size={15} />
                            </Link>
                            <a href="/whitelabel#book-a-call" data-testid="powered-by-call"
                                className={`inline-flex items-center gap-2 rounded-full border px-6 py-3 text-sm font-bold uppercase tracking-wide ${loud ? "border-white/30 text-white hover:border-white" : "border-zinc-300 text-zinc-900 hover:border-zinc-900"}`}>
                                Book a 10-minute call
                            </a>
                        </div>
                    </div>
                    <ul className="grid gap-3 sm:grid-cols-3 lg:grid-cols-1">
                        {[
                            [Store, "Your logo, your colors and your web address.", "Start on yourname.13thav.com, or point your own domain at it."],
                            [Palette, "Every live designer is included.", "White tees, colored apparel, DTF gang sheets and every sign product."],
                            [Globe, "Print it yourself, or let 13thav print and ship it.", "You pick shelf by shelf, and you keep 20% on anything 13thav prints."],
                        ].map(([Icon, head, sub]) => (
                            <li key={head} className={`flex items-start gap-3 rounded-2xl border p-4 ${loud ? "border-white/10 bg-white/5" : "border-black/10 bg-white"}`}>
                                <Icon size={18} className={loud ? "mt-0.5 shrink-0 text-blue-300" : "mt-0.5 shrink-0 text-blue-700"} />
                                <span>
                                    <span className={`block text-sm font-bold ${loud ? "text-white" : "text-zinc-900"}`}>{head}</span>
                                    <span className={`block text-xs ${loud ? "text-zinc-400" : "text-zinc-500"}`}>{sub}</span>
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
